import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';
import { environment } from "../../environments/environment";
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import * as moment from 'moment-timezone';
import { isEmpty, get, has, merge, omit } from 'lodash';
import { Subject, throwError, Observable, BehaviorSubject, of } from 'rxjs';
import { AppConstants } from '../global/constants';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { apiLinks } from '../core/api-links/api-links';
import { AlertsService } from './alerts.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { identifierToJsonKey  } from 'src/app/core/model/common';
var CryptoJS = require("crypto-js");

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  thumbs_up = "assets/images/transaction/thumbs-up.png";
  thumbs_down = "assets/images/transaction/thumbs-down.png";
  returnUrl = "/";
  constructor(private httpClient: HttpClient,
    private responsive: BreakpointObserver,
    private handleError: ErrorHandlerService,
    private alertService: AlertsService, 
    private messageService: MessageService,
    private translate: TranslateService ) {
    this.responsive.observe(['(max-width: 991px)'])
      .subscribe(result => {
        this.isMobileView = result.matches;
        this.$breakpoint.next(this.isMobileView);
      });
  }

  public isMobileView: boolean = false;
  public $breakpoint: Subject<boolean> = new Subject();

  private readonly openJobHistoryPanelSubject = new Subject<void>();

  openJobHistoryPanel(): void {
    this.openJobHistoryPanelSubject.next();
  }

  onOpenJobHistoryPanel(): Observable<void> {
    return this.openJobHistoryPanelSubject.asObservable();
  }

  public paymentDetailsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public setPaymentDetails(paymentDetails: any) {
    this.paymentDetailsSubject.next(paymentDetails);
  }

  public sessionStorageKeys = {
    runASale: 'run_a_sale_data',
    itemizedBilling: 'itemized_billing_customer_data',
    sendPayLink: 'send_payment_link_data',
    createInvoiceJump: 'create_invoice_jump'
  }

  getCommonHttpClientParams(urlAppendedString) {
    return this.httpClient.get(urlAppendedString).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  getCustomerIdByIsv(){
    return this.httpClient.get(apiLinks.getCustomerByIsv).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    )
  }

  getCommonFileDownload(urlAppendedString, params = {}) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    return this.httpClient.get(urlAppendedString, { responseType: "blob", params: httpParams }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  getCommonHttpClientQueryParams(url, params) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    return this.httpClient.get(url, { params: httpParams }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  getCommonHttpTimeout(url, params, time) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    return this.httpClient.get(url, { headers: new HttpHeaders({ timeout: `${time * 1000}` }), params: httpParams }).pipe(
      // timeout(time*1000),
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getResponseDataForFilter(url, params) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    return this.httpClient.get(url, { params: httpParams }).pipe(
      map((res: any) => {
        if (res.data && res.data.items) {
          return res.data.items;
        }
        return res.data;
      }),
      catchError(this.handleError.handleError)
    );
  }

  postCommonHttpClient(url, data, httpOptions = {}) {
    return this.httpClient.post(url, data, httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  postCommonHttpClientWithProgress(url, data) {
    return this.httpClient.post(url, data, {
      reportProgress: true,
      observe: 'events'
    });
  }

  postCommonHttpClientWithParams(url, data, params) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    return this.httpClient.post(url, data, { params: httpParams }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  putCommonHttpClient(url, data) {
    return this.httpClient.put(url, data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  putCommonHttpClientWithParams(url, data, params) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    return this.httpClient.put(url, data, { params: httpParams }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  deleteCommonHttpClient(url) {
    return this.httpClient.delete(url).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  deleteCommonHttpClientParams(url, data, params) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      httpParams = httpParams.append(key, params[key]);
    });
    const options: any = { params: httpParams };
    if (data) {
      options.body = data;
    }
    return this.httpClient.delete(url, options).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  async doubleExtensionCheck(originalFileName) {
    let supportedExtensions = ['jpg', 'jpeg', 'png', 'svg', 'xls', 'xlsx', 'apk'];
    let doubleExtensionCheck = originalFileName.split(".");
    let extensionCount = 0;
    console.log(doubleExtensionCheck);
    if (doubleExtensionCheck.length > 2) {
      await doubleExtensionCheck.forEach(async data => {
        extensionCount = supportedExtensions.indexOf(data) > -1 ? extensionCount + 1 : extensionCount;
      });
      console.log(extensionCount);
      if (extensionCount > 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  downloadAsExcel(workBokData, commentsData = null) {
    let workbook = new Workbook();
    let sheet;
    for (let i = 0; i < workBokData.worksheet.length; i++) {
      const ws = workBokData.worksheet[i];

      if (has(ws, 'frozen') && get(ws, 'frozen')) {
        sheet = workbook.addWorksheet(ws.name, {
          views: [{ state: "frozen", ySplit: 1 }],
        });
      } else {
        sheet = workbook.addWorksheet(ws.name);
      }

      sheet.columns = ws.columns;
      sheet.properties.defaultColWidth = 18;
      if (ws.isRow == 1) {
        sheet.addRow(this.setFlattenData(ws.rows, get(ws, 'isJSONKey'), get(ws, 'flattenKeyname')), "n");
      } else {
        sheet.addRows(this.setFlattenData(ws.rows, get(ws, 'isJSONKey'), get(ws, 'flattenKeyname')));
      }

      if (ws.name === "Details" && !isEmpty(commentsData)) {
        const storeFeeData = commentsData.storeFeeData || (commentsData.singleTpnFee != null ? commentsData : null);
        const unattendedFeeData = commentsData.unattendedFeeData || null;
        const headerRow = sheet.getRow(1);
        const fixedFeeCell = headerRow.getCell("fixedFee");
        const noteTexts = [];
        if (!isEmpty(storeFeeData)) {
          noteTexts.push(
            { text: `Single TPN Fee: $${Number(storeFeeData.singleTpnFee || 0).toFixed(2)}\n` },
            { text: `Dual TPN Fee: $${Number(storeFeeData.dualTpnFee || 0).toFixed(2)}\n` },
            { text: `Triple TPN Fee: $${Number(storeFeeData.tripleTpnFee || 0).toFixed(2)}\n` },
            { text: `Multiple TPN Fee: $${Number(storeFeeData.multipleTpnFee || 0).toFixed(2)}` }
          );
        }
        if (!isEmpty(unattendedFeeData)) {
          if (noteTexts.length) {
            noteTexts.push({ text: `\n` });
          }
          noteTexts.push(
            { text: `Unattended Primary TPN Fee: $${Number(unattendedFeeData.unattendedPrimaryTpnFee || 0).toFixed(2)}\n` },
            { text: `Unattended Add-on TPN Fee: $${Number(unattendedFeeData.unattendedAddOnTpnFee || 0).toFixed(2)}` }
          );
        }
        if (noteTexts.length) {
          fixedFeeCell.note = {
            texts: noteTexts,
            margins: {
              insetmode: "auto",
              inset: [0.25, 0.25, 0.35, 0.35]
            }
          };
        }
      }
    }

    return workbook.xlsx.writeBuffer().then(function (data) {
      var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      fs.saveAs(blob, workBokData.fileName);
    })
  }

  setFlattenData(data: any, flag: boolean = false, flattenKeyname: string = "") {
    if (flag == true && !isEmpty(flattenKeyname)) {
      return data.map(currentData => {
        if (typeof currentData[flattenKeyname] == 'string') {
          currentData[flattenKeyname] = JSON.parse(currentData[flattenKeyname]);
        }
        return { ...currentData, ...currentData[flattenKeyname] };
      })
    }
    return data;
  }
  estTimeConvert(date) {
    return moment.tz(date, 'America/New_York').format('MM-DD-YYYY HH:mm');
  }

  getSessionData(key) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  setSessionData(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
    return data;
  }
  months = moment.monthsShort();
  getMonthName(value) {
    return this.months[value - 1];
  }
  getAccountPersonalData(keyName) {
    let envVersionKeys = {
      'dev': "Ll5IpPylxLY48YPnBkQyXPXwlnFEFbfatFzRDxmnOP0",
      'uat': "COmyP3EdIch1bRE3G4G9We4BuZSGg8ThqFpuzR",
      'qa': "A8xQ2LmZpR7vT4KtYw8HdNfJ3UcB5eG1oPiX0rVb",
      'preprod' :"Cr7xM2pQ5A9ZrL0YkV8F3d1sK6hT4BqWnEoXyGuT",
      'prod': "PnBkQyXLl5IpPylxLY48YPXwlnFEFbfatFzRDxmnOP0"
    }
    let temp = {
      pgPersonalKey: "portal-pg=Token-phase-1",
      secretKeyCryptoToken: "portal-Temp=Token-phase-1",
      pstwd: envVersionKeys[environment?.environmentName]
    }
    return has(temp, keyName) ? temp[keyName] : '';
  }
  getPOSMode(POSID: any) {
    if (has(environment.POSMode, POSID)) {
      return environment.POSMode[POSID]
    } else { return 'N/A' }
  }
  getChannel(type) {
    return (AppConstants.EsourceType[type] ? AppConstants.EsourceType[type] : type);
  }
  is3DSecure(transactionData) {
    let tsys = transactionData?.tsysRespData;
    if (typeof tsys === 'string') {
      try {
        tsys = JSON.parse(tsys);
      } catch {
        tsys = {};
      }
    }
    const result = tsys?.NSE === 'Y' ? 'Yes' : 'No';
    return result;
  }

  getIdentifier(data) {
    if (isEmpty(data)) {
      return '';
    }
    let modelData = JSON.parse(data);
    return modelData?.identifier;
  }
  getMinorChannel(transactionData) {
    try {
      const base = transactionData?.txbase_from_txextns?.customField;
      const alt = transactionData?.txalternate_from_txextns?.customField;

      let data: any = null;

      if (base) {
        const parsed = typeof base === 'string' ? JSON.parse(base) : base;
        data = parsed?.additionalEntryMode ?? null;
      } else if (alt) {
        const parsed = typeof alt === 'string' ? JSON.parse(alt) : alt;
        data = parsed?.additionalEntryMode ?? null;
      }

      return data != null && environment.minorChannel?.hasOwnProperty(data)
        ? environment.minorChannel[data]
        : 'N/A';
    } catch {
      return 'N/A';
    }

  }

  getPerformedBy(transactionData) {
    try {
      const baseField = transactionData?.txbase_from_txextns?.customField;
      if (baseField) {
        const parsed = typeof baseField === 'string' ? JSON.parse(baseField) : baseField;
        return parsed?.performedBy || 'N/A';
      }

      const altField = transactionData?.txalternate_from_txextns?.customField;
      const parsedAlt = typeof altField === 'string' ? JSON.parse(altField) : altField;
      return parsedAlt?.performedBy || 'N/A';
    } catch {
      return 'N/A';
    }
  }

  getCustomFieldValue(transactionData, key) {
    try {
      const baseField = transactionData?.txbase_from_txextns?.customField ?? transactionData?.customField;
      if (baseField) {
        const parsed = typeof baseField === 'string' ? JSON.parse(baseField) : baseField;
        const result = parsed?.[key] || 'N/A';
        return result;
      }

      const altField = transactionData?.txalternate_from_txextns?.customField;
      const parsedAlt = typeof altField === 'string' ? JSON.parse(altField) : altField;
      const altResult = parsedAlt?.[key] || 'N/A';
      return altResult;
    } catch (e) {
      return 'N/A';
    }
  }

  getFeedBack(transactionData) {
    const baseField = transactionData?.txbase_from_txextns?.customField ?? transactionData?.customField;
    const altField = transactionData?.txalternate_from_txextns?.customField;
    const field = baseField || altField;
    let data = null;

    if (field) {
      try {
        const parsed = typeof field === 'string' ? JSON.parse(field) : field;
        data = parsed?.surveyAns || null;
      } catch (e) {
        return 'N/A';
      }
    } else {
      return 'N/A';
    }
    const result = data == "1" ? this.thumbs_up : data == "0" ? this.thumbs_down : "N/A";
    return result;
  }

  markAllControlsAsDirty(abstractControls: AbstractControl[]): void {
    abstractControls.forEach((abstractControl) => {
      if (abstractControl instanceof UntypedFormControl) {
        (abstractControl as UntypedFormControl).markAsDirty({ onlySelf: true });
      } else if (abstractControl instanceof UntypedFormGroup) {
        this.markAllControlsAsDirty(
          Object.values((abstractControl as UntypedFormGroup).controls)
        );
      } else if (abstractControl instanceof UntypedFormArray) {
        this.markAllControlsAsDirty((abstractControl as UntypedFormArray).controls);
      }
    });
  }

  getFormattedDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    let formattedTimeZones = { formattedDateTime, formattedTime }
    return formattedTimeZones;

  }

  customAdd(a, b) {
    a = isNaN(a) ? 0 : a;
    b = isNaN(b) ? 0 : b;

    return a + b;
  }

  getBrowserName() {
    let browserInfo = navigator.userAgent;
    let browser;
    if (browserInfo.includes('Opera') || browserInfo.includes('Opr')) {
      browser = 'Opera';
    } else if (browserInfo.includes('Edg')) {
      browser = 'Edge';
    } else if (browserInfo.includes('Chrome')) {
      browser = 'Chrome';
    } else if (browserInfo.includes('Safari')) {
      browser = 'Safari';
    } else if (browserInfo.includes('Firefox')) {
      browser = 'Firefox'
    } else {
      browser = 'unknown'
    }
    return browser;
  }

  getMfaFingerPrint() {
    return {
      browserVersion: "123.0.0.0",
      browserName: this.getBrowserName(),
      plugIn: "Adobe Flash Player",
      userAgent: navigator.userAgent,
      timeZone: "UTC+02:00",
      screenResolution: `${window.innerWidth} x ${window.innerHeight}`,
      cookies: "true",
      longitude: "-73.9857",
      latitude: "40.7484"
    }
  }

  uploadToS3(file: File, presignedUrl: string): Observable<any> {
    return this.httpClient.put(presignedUrl, file, {
      headers: new HttpHeaders({ 'Content-Type': file.type }),
      reportProgress: true,
      observe: 'events'
    });
  }

  private selectedTPNS = new BehaviorSubject<any[]>([]);
  private resetSelected = new BehaviorSubject<any>('');
  private selectedCountSubject = new BehaviorSubject<number>(0);

  public selectedTPNSObservable = this.selectedTPNS.asObservable();
  public resetSelectedObservables = this.resetSelected.asObservable();
  public selectedCountObservable = this.selectedCountSubject.asObservable();

  processNatsData(type: string, data?: any) {
    if (type === 'setSelectedValues') {
      this.selectedTPNS.next(data || []);
    }

    if (type === 'getTpns') {
      return this.selectedTPNS.getValue();
    }

    if (type === 'clearTpns') {
      this.selectedTPNS.next([]);
      this.selectedCountSubject.next(0);
    }

    if (type === 'restTpns') {
      this.resetSelected.next("reset");
    }

    if (type === 'setSelectedCount') {
      this.selectedCountSubject.next(Number(data) || 0);
    }
  }
  getCCCTemplate(params): Observable<any> {
    return this.getCommonHttpClientQueryParams(apiLinks.communicationCenter.getControlTemplate, params)
  }
  getCommnCCCAPI(link, params): Observable<any> {

    if (link === '/communication/timezones') {
      const timeZones = moment.tz.names();
      const result = timeZones.map(e => ({ name: e }));
      console.log(result);
      
       return of({ data: result });
    }

    params = { ...params, templateName: "device_config_form" };
    return this.getCommonHttpClientQueryParams(`${environment.cccApiUrl}${link}`, params);
  }
  triggerNats(data): Observable<any> {
    return this.postCommonHttpClient(apiLinks.communicationCenter.triggerNats, data)

  }

  listCccJobs(params: {
    page?: number;
    pageSize?: number;
    q?: string;
    sort?: string;
    status?: string;
    commandType?: string;
  }): Observable<any> {
    const clean: Record<string, string | number> = {};
    if (params.page != null) clean.page = params.page;
    if (params.pageSize != null) clean.pageSize = params.pageSize;
    if (params.q) clean.q = params.q;
    if (params.sort) clean.sort = params.sort;
    if (params.status) clean.status = params.status;
    if (params.commandType) clean.commandType = params.commandType;
    return this.getCommonHttpClientQueryParams(
      apiLinks.communicationCenter.cccJobs,
      clean
    );
  }

  getCccJob(jobId: string): Observable<any> {
    return this.getCommonHttpClientParams(
      `${apiLinks.communicationCenter.cccJobs}/${encodeURIComponent(jobId)}`
    );
  }

  getCccJobCsvDownload(jobId: string): Observable<any> {
    return this.getCommonHttpClientParams(
      `${apiLinks.communicationCenter.cccJobs}/${encodeURIComponent(jobId)}/csv-download`
    );
  }

  normalizeCccTriggerResponse(res: any): {
    success: boolean;
    jobId: string | null;
    csvDownloadUrl: string | null;
    message?: string;
  } {
    if (!res || typeof res !== 'object') {
      return { success: false, jobId: null, csvDownloadUrl: null };
    }
    const jobIdRaw = res.jobId ?? res.data?.jobId;
    const jobId =
      jobIdRaw != null && String(jobIdRaw).trim()
        ? String(jobIdRaw).trim()
        : null;
    let csvDownloadUrl: string | null = null;
    for (const u of [res.csvDownloadUrl, res.data?.csvDownloadUrl]) {
      if (typeof u === 'string' && this.isValidCccDownloadUrl(u)) {
        csvDownloadUrl = u.trim();
        break;
      }
    }
    return {
      success: res.success === true,
      jobId,
      csvDownloadUrl,
      message: res.message ?? res.data?.message,
    };
  }

  isValidCccDownloadUrl(url: string): boolean {
    if (!url || typeof url !== 'string') {
      return false;
    }
    const trimmed = url.trim();
    if (!trimmed) {
      return false;
    }
    try {
      const parsed = new URL(trimmed);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false;
    }
  }

  triggerPresignedCsvDownload(url: string): void {
    if (typeof document === 'undefined' || !this.isValidCccDownloadUrl(url)) {
      return;
    }
    const trimmed = url.trim();
    try {
      const anchor = document.createElement('a');
      anchor.href = trimmed;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } catch {
      if (typeof window !== 'undefined') {
        window.open(trimmed, '_blank', 'noopener');
      }
    }
  }

  downloadCccCsvByJobId(
    jobId: string
  ): Observable<{ ok: boolean; message?: string }> {
    return this.getCccJobCsvDownload(jobId).pipe(
      map((res: any) => {
        const url = res?.data?.url;
        if (typeof url === 'string' && this.isValidCccDownloadUrl(url)) {
          this.triggerPresignedCsvDownload(url);
          return { ok: true };
        }
        return { ok: false, message: 'CSV report is not available.' };
      }),
      catchError((err) =>
        of({
          ok: false,
          message:
            err?.error?.message || err?.message || 'CSV download failed.',
        })
      )
    );
  }

  downloadCccCsvFromTriggerResponse(
    res: any
  ): Observable<{ ok: boolean; message?: string }> {
    const norm = this.normalizeCccTriggerResponse(res);
    if (norm.csvDownloadUrl) {
      this.triggerPresignedCsvDownload(norm.csvDownloadUrl);
      return of({ ok: true });
    }
    if (norm.jobId) {
      return this.downloadCccCsvByJobId(norm.jobId);
    }
    return of({ ok: false, message: 'CSV download URL is not available.' });
  }

  downloadCccCsvByJobIdOrUrl(
    jobId: string,
    inlineUrl?: string | null
  ): Observable<{ ok: boolean; message?: string }> {
    if (inlineUrl && this.isValidCccDownloadUrl(inlineUrl)) {
      this.triggerPresignedCsvDownload(inlineUrl);
      return of({ ok: true });
    }
    return this.downloadCccCsvByJobId(jobId);
  }

postCommonFileDownload(
    url: string,
    body: Record<string, any> = {},
    queryParams: Record<string, any> = {}
  ): Observable<Blob> {
    let params = new HttpParams();
    Object.entries(queryParams).forEach(([k, v]) => {
      params = params.append(k, v);
    });

    return this.httpClient.post(url, body, {
      params,
      responseType: 'blob'
    });
  }

  zipCodeValidator(): ValidatorFn {
  const usPattern = /^\d{5}$/;
  const caPattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i; 
  return (control: AbstractControl): ValidationErrors | null => {
    let value = ((typeof control.value == 'string' ?  control.value : control.value?.zip_code )|| '').toString().trim();
    if (!value) return null; 
    value = value.toUpperCase();
    if (usPattern.test(value)) {
      if (/^0{5}$/.test(value)) {
        return { pattern: true, reason: 'US zip cannot be all zeros' };
      }
      return null;
    }
    if (caPattern.test(value)) {
      return null;
    }
    return { pattern: true };
  };
  }

    fileSizeRestriction = 100400

   async isFileValidationsSuccess(file: File) {
  
      if (file?.size == 0) {
        return { status: false, message: "please select a image", url: null }
      }
  
      if (file.type !== 'image/png') {
        return { status: false, message: "Image type should be png", url: null }
      }
  
      if (file.size > this.fileSizeRestriction) {
        return { status: false, message: "Image size should be less than 100KB", url: null }
      }
       
      const signatureValid = await this.isValidPNGBySignature(file);
      if (!signatureValid) {
        return { status: false, message: "Image is not valid", url: null }
      }
  
      try {
  
  
        const res = await this.checkFileDimenstions(file)
        return res
      }
      catch (err) {
        return { status: false, message: err?.message || "Image is not valid", url: null }
      }
    }
  
    async checkFileDimenstions(file: File) {
  
      const Img = new Image();
  
      const IMinWidth = 100, IMaxWidth = 120, IMinHeight = 80, IMaxHeight = 100;
  
      const response: { status: boolean, message: string, url: null | string } = await new Promise((res, rej) => {
  
        try {
          Img.src = URL.createObjectURL(file);
          Img.onload = (event) => {
            const { width, height } = Img;
            if ((width <= IMaxWidth && width >= IMinWidth) && (height <= IMaxHeight && height >= IMinHeight)) {
              res({ status: true, message: "Image is valid", url: Img.src })
            }
            else {
              const invalidImage = `Image dimensions should be ${IMinWidth}-${IMaxWidth}px (width) and ${IMinHeight}-${IMaxHeight}px (height).
  `
              this.showAlert("Image is not valid", "Invalid Image", "warn")
              res({ status: false, message: invalidImage, url: null })
            }
          }
        }
  
        catch (err) {
          rej({ status: false, message: err?.message || "Image is not valid", url: null })
  
        }
      })
  
      return response
  
    }
      async isValidPNGBySignature(file) {
    const signature = new Uint8Array(await file.slice(0, 8).arrayBuffer());
    const pngSignature = [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A];
    return pngSignature.every((byte, index) => signature[index] === byte);
  }
   showAlert(detail, summary, severity) {
    this.alertService.showPToast(this.messageService, { summary, detail, sticky: false, key: "store-logo" }, severity)
  }

  postLog(requestBody){
    let reqBody = {
      type: requestBody.type || "ACTIVITY",
      apiName: requestBody.apiName,
      message: requestBody.message,
      info: requestBody.info,
      log_data: requestBody.log_data || {},
    };
    this.postCommonHttpClient(apiLinks.postLog, reqBody).subscribe((res) => {
      console.log(res);
    });
  }
  
  getUpdatedIdentifier(
    identifier: any,
    fallback: string = 'NA'
  ): string {
    if (identifier === null || identifier === undefined) return fallback;
    const idStr = String(identifier).trim().toLowerCase(); // Normalize to lowercase
    if (!idStr) return fallback;
    const key = identifierToJsonKey[idStr];
    return key
      ? this.translate.instant(`deviceModel.${key}`)
      : identifier; // Return original identifier, not lowercased
  }


  
  postPockytList(payload: any) {
    return this.postCommonHttpClientWithParams(apiLinks.postPockytList, payload, {});
  }
}

